export default __webpack_public_path__ + "images/48b13480c7ad2d35289bb0bb04091bfb.png";